import { produce } from 'immer';

import { ActionTypes } from './actions';
import type { AppMigrationState, IAppMigrationAction } from './types';

export const initialState = Object.freeze<AppMigrationState>({
  isTopBannerDismissed: false,
});

export default (
  state: AppMigrationState = initialState,
  action: IAppMigrationAction
): AppMigrationState =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActionTypes.DISMISS_TOP_BANNER: {
        draft.isTopBannerDismissed = true;
        break;
      }
      default:
        break;
    }
  });
